module.exports = __webpack_public_path__ + "img/bjc-flyer.aafb9b70.jpg";